"use client";

import { HeaderDisplay } from "./HeaderDisplay";

export function HeaderSection() {
  return (
    <div className="space-y-4">
      <HeaderDisplay />
    </div>
  );
}
